import { useTradePairInfos } from '@ui/hooks/trade/useTradePairInfos';
import { TradePair } from '@ui/types/tradePair';

export const useIsTradePairSupportDegen = (
  tradePair: TradePair,
  opts?: {
    exact?: boolean;
  },
) => {
  const pairs = useTradePairInfos();

  return (
    pairs.find(
      (pair) =>
        (opts?.exact
          ? pair.address.toLowerCase() === tradePair.address.toLowerCase()
          : pair.baseSymbol === tradePair.baseSymbol) && pair.isDegenPair,
    ) !== undefined
  );
};
